import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';

export const StyledApplyAction = styled(Button)<{ $isWideButton: boolean }>`
  width: 100%;

  @media ${mediaConfined} {
    width: ${({ $isWideButton }) => ($isWideButton ? '50%' : 'max-content')};
  }
`;
